module.exports = __webpack_public_path__ + "img/price_credits.02031ca6.svg";